import React from 'react'
import steppertwoStyle from './RegistermobilStepTwo.module.css'

export default function RegistermobilStepTwo() {
  return (
    <>
      <div className={steppertwoStyle.stepperTwo}>
        <div className='row'>
          <div className='col-7'>
            <h3> About Your School </h3>
          </div>
          <div className='col-5'>
            <div className={steppertwoStyle.profileBox}>
              <div className={steppertwoStyle.profileImg}>
                <div className={steppertwoStyle.profileImginner}>
                  <img src="/static/media/lady-img.965cec88308ed5853d74.png" className="img-fluid w-100 h-100 rounded-circle" />
                </div>
              </div>
              <div className={steppertwoStyle.profileeditBox}>
                <input type="file" className={steppertwoStyle.profilechooseInput} accept=".png, .jpg, .jpeg" />
                <label className={steppertwoStyle.profileLabel} for="imageUpload" />
              </div>
            </div>
          </div>
        </div>
        <h5> School Information </h5>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <input type="text" className={`${steppertwoStyle.twoInput} form-control`} placeholder='School Name' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <input type="text" className={`${steppertwoStyle.twoInput} form-control`} placeholder='Street Address' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <input type="text" className={`${steppertwoStyle.twoInput} form-control`} placeholder='City' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-6'>
            <div className="mb-3">
              <input type="email" className={`${steppertwoStyle.twoInput} form-control`} placeholder='State' />
            </div>
          </div>
          <div className='col-6'>
            <div className="mb-3">
              <input type="email" className={`${steppertwoStyle.twoInput} form-control`} placeholder='Zip' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
